import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';
import {
  InfoBlockConfig,
  InfoBlockLinkType,
  InfoBlockModule,
  InfoBlockType,
} from '@commons/info-block/info-block.component';
import { TrainingObligationPhoneNumberModule } from '@domains/training-obligation/training-obligation-phone-number/training-obligation-phone-number.component';
import { environment } from '@environment';

@Component({
  selector: 'app-training-orientation',
  templateUrl: './training-orientation.component.html',
  styleUrls: ['./training-orientation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainingOrientationComponent {
  @Output() tracker = new EventEmitter<string>();

  onisepConfig: InfoBlockConfig = {
    type: InfoBlockType.CENTER,
    title: {
      main: 'Une plateforme',
      emphasis: 'pour informer',
    },
    button: {
      link: 'https://www.nouvelles-chances.gouv.fr/',
      type: InfoBlockLinkType.HREF,
      text: 'En savoir plus',
      ariaLabel: 'Lien vers le site nouvelles-changes.gouv.fr',
    },
    img: {
      src: `${environment.wizbiiImages}/training-obligation/onisep.png`,
    },
  };

  onTrackerClicked(action: string): void {
    this.tracker.emit(action);
  }
}

@NgModule({
  imports: [TrainingObligationPhoneNumberModule, InfoBlockModule, ExternalLinkDirectiveModule],
  declarations: [TrainingOrientationComponent],
  exports: [TrainingOrientationComponent],
})
export class TrainingOrientationModule {}
